// Copyright (c) Docugami, Inc. All rights reserved.

import { appBackgroundGrey } from "components/shell/presentation/AppStyles";
import styled from "styled-components";

export const GenericContainer = styled.div`
    border-radius: 20px;
    background: ${appBackgroundGrey};
    display: flex;
`;

export const StepCanvas = styled(GenericContainer)`
    flex: 1;
    box-sizing: border-box;
    padding: 20px;
`;

export const PickerContainer = styled(GenericContainer)`
    flex-direction: column;
    width: 100%;
    height: 100%;
    background: #FFFFFF;
    flex: auto;
`;

